var slider = {
    selector: '*[data-slider="element"]',
    init: function () {
        var self = this,
            $element = $(self.selector);

        $element.each(function () {
            var $el = $(this),
                $slides = $el.find('[data-slider="slides"]'),
                $prev = $el.find('[data-slider="prev"]'),
                $next = $el.find('[data-slider="next"]'),
                $nav = $el.find('[data-slide]'),
                $current = $el.find('[data-slider="current"]');

            var tinyslider = tns({
                container: $slides[0],
                items: 1,
                slideBy: 'page',
                autoplay: false,
                controls: false,
                loop: false,
                nav: false,
                mode: 'gallery',
                speed: 1000,
            });

            tinyslider.events.on('indexChanged', function (info) {
                $current.html(info.displayIndex);
                $nav.removeClass('active');
                $nav.filter('[data-slide="' + info.index + '"]').addClass(
                    'active'
                );
            });

            $prev.on('click', function () {
                tinyslider.goTo('prev');
            });

            $next.on('click', function () {
                tinyslider.goTo('next');
            });

            $nav.on('click', function () {
                var index = $(this).data('slide');
                tinyslider.goTo(index);
            });
        });
    },
};

export { slider };
